import { LOAD_USER_SUCCESS, LOAD_USER_FAILURE } from "../types";

const initialState = {
  user: null,
  company: null,
  error: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_USER_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        company: action.payload.company,
      };
    case LOAD_USER_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
